import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { TablePagination } from '@material-ui/core';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import InputSelect from '../ui/inputSelect'; // api

import { getLogsLogisticsForecast } from '../../api/statsAPI'; // redux

import { setLogisticsForecast, setLogisticsForecastSort } from '../../redux/line-dashboard';
var t = i18n.getFixedT(null, 'line-dashboard');
var gt = i18n.getFixedT(null, 'app');

var LogisticsListForcastTable = function LogisticsListForcastTable() {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$lineDash = _useSelector.lineDashboard,
      logisticsForecast = _useSelector$lineDash.logisticsForecast,
      logisticsForecastSort = _useSelector$lineDash.logisticsForecastSort,
      logisticsList = _useSelector.app.logisticsList;

  var dispatch = useDispatch();

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      curLogisticsId = _useState2[0],
      setCurLogisticsId = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCount = _useState4[0],
      setTotalCount = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState('notZoneIn'),
      _useState10 = _slicedToArray(_useState9, 2),
      deliverStatus = _useState10[0],
      setDeliverStatus = _useState10[1];

  var isMounted = useRef(false);
  useEffect(function () {
    if (isMounted.current) {
      var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
      getLogsLogisticsForecast(contextRoot, false, curLogisticsId, deliverStatus, logisticsForecastSort, offset, rowsPerPage).then(function (result) {
        if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

        var newData = _.cloneDeep(result);

        _.map(newData.content, function (el, index) {
          el.sequence = offset + index + 1;
        });

        dispatch(setLogisticsForecast(newData));
      });
    }
  }, [curLogisticsId, JSON.stringify(logisticsForecastSort), currentPage, rowsPerPage, deliverStatus]);
  useEffect(function () {
    if (isMounted.current && logisticsForecast.totalElements !== totalCount) setTotalCount(logisticsForecast.totalElements);
  }, [JSON.stringify(logisticsForecast)]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
  }, []);

  var handleSort = function handleSort(sort) {
    dispatch(setLogisticsForecastSort(sort));
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleSplitTime = function handleSplitTime(time) {
    if (_.isEmpty(time)) return '';
    var timeAry = time.split(' ');
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, timeAry[0]), /*#__PURE__*/React.createElement("div", null, timeAry[1]));
  };

  var handleChangeInputSelect = function handleChangeInputSelect(item) {
    if (_.isEmpty(item)) return;
    if (item === 'all' || item.value === 'all') return setCurLogisticsId('');
    setCurLogisticsId(item.value);
  };

  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'deliverType', {
    label: t('lbl-container-deliver-types'),
    sortable: true,
    formatter: function formatter(val, row) {
      return val ? t('lbl-' + val.toUpperCase()) : '';
    }
  });

  _.set(fields, 'trailerPlateNo', {
    label: t('lbl-trailerPlateNo'),
    sortable: true
  });

  _.set(fields, 'transportType', {
    label: t('lbl-transport-type'),
    sortable: true
  });

  _.set(fields, 'containerType', {
    label: t('lbl-container-type'),
    sortable: true
  });

  _.set(fields, 'containerNo', {
    label: t('lbl-container-number'),
    sortable: true
  });

  _.set(fields, 'oriTerminalName', {
    label: t('lbl-ori-terminal'),
    sortable: true
  });

  _.set(fields, 'dstTerminalName', {
    label: t('lbl-dst-terminal'),
    sortable: true
  });

  _.set(fields, 'logisticName', {
    label: t('lbl-logistic-name'),
    sortable: true,
    formatter: function formatter(val) {
      return /*#__PURE__*/React.createElement("div", {
        className: "text"
      }, val);
    }
  }); // _.set(fields, 'driverNationId', { label: t('lbl-driver-nation-id'), sortable:true })


  _.set(fields, 'estBeginTime', {
    label: t('lbl-est-begin-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'oriZoneOutTime', {
    label: t('lbl-ori-zone-out-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstZoneInTime', {
    label: t('lbl-dst-zone-in-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstTerminalInTime', {
    label: t('lbl-dst-terminal-in-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstTerminalOutTime', {
    label: t('lbl-dst-terminal-out-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'containerDeliverStatus', {
    label: t('lbl-working-status'),
    formatter: function formatter(val) {
      return /*#__PURE__*/React.createElement("div", {
        className: "text"
      }, val);
    }
  });

  var deliverStatusList = [{
    value: 'notZoneIn',
    text: t('lbl-notZoneIn')
  }, {
    value: 'zoneIn',
    text: t('lbl-zoneIn')
  }, {
    value: 'terminalIn',
    text: t('lbl-terminalIn')
  }, {
    value: 'terminalOut',
    text: t('lbl-terminalOut')
  }, {
    value: 'zoneOut',
    text: t('lbl-zoneOut')
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "logisticsList-forecast-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-logistic-container-deliver-forecast-list')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-logistic-name'), ": "), /*#__PURE__*/React.createElement(InputSelect, {
    className: "inputSelect",
    options: logisticsList,
    onChange: handleChangeInputSelect
  })), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-working-status'), ": "), /*#__PURE__*/React.createElement(DropDown // defaultText={t('lbl-all-logistic-name')}
  , {
    required: true,
    list: deliverStatusList,
    value: deliverStatus,
    onChange: function onChange(value) {
      return setDeliverStatus(value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt dataTable-wrap"
  }, /*#__PURE__*/React.createElement(DataTable, {
    enableTextWordWrap: true,
    fields: fields,
    data: logisticsForecast.content ? logisticsForecast.content : '',
    sort: logisticsForecastSort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }));
};

export default LogisticsListForcastTable;